export enum ReportFilterTimeframeType {
    day_by_daytime = 'day_by_daytime',
    weekday_month_by_daytime = 'weekday_month_by_daytime',
    month_by_daytime = 'month_by_daytime',
    month_by_day = 'month_by_day',
    weekday_year_by_daytime = 'weekday_year_by_daytime',
    year_by_daytime = 'year_by_daytime',
    year_by_month = 'year_by_month'
}

export enum ReportFilterType {
    none = 'none',
    options = 'options',
    structure = 'structure'
}

export class ReportFilterModel {

    timeframeType = ReportFilterTimeframeType.day_by_daytime;
    day: number;
    month: number;
    year: number;
    filterType: ReportFilterType = ReportFilterType.none;
    transportOptionIds = new Set<number>();
    stationGroupId: number;
    stationSetId: number;
    stationId: number;

    constructor(filter?: ReportFilterModel) {
        if (filter != null) {
            this.timeframeType = filter.timeframeType;
            this.day = filter.day;
            this.month = filter.month;
            this.year = filter.year;
            this.filterType = filter.filterType;
            if (filter.transportOptionIds != null) {
                for (const id of filter.transportOptionIds) {
                    this.transportOptionIds.add(id);
                }
            }
            this.stationGroupId = filter.stationGroupId;
            this.stationSetId = filter.stationSetId;
            this.stationId = filter.stationId;
        }
    }
}
